import { getHandler, patchHandler, postHandler } from 'src/utils/fetchHandler';
import { getAuthHost } from 'src/utils/getAuthHost';
import {
	getPendingAuthOrganizationUpdate,
	getPendingAuthOrganizationCreate,
} from './authOrganization.selector';

export const CLEAR_AUTH_ORGANIZATIONS = 'CLEAR_AUTH_ORGANIZATIONS/AUTH_ORGANIZATION/@WISELY/WEB';
export const CLEAR_AUTH_ORGANIZATION_UPDATE_ERRORS =
	'CLEAR_AUTH_ORGANIZATION_UPDATE_ERRORS/AUTH_ORGANIZATION/@WISELY/WEB';
export const CLEAR_AUTH_ORGANIZATION_CREATE_ERRORS =
	'CLEAR_AUTH_ORGANIZATION_CREATE_ERRORS/AUTH_ORGANIZATION/@WISELY/WEB';
export const GET_AUTH_ORGANIZATION = 'GET_AUTH_ORGANIZATION/AUTH_ORGANIZATION/@WISELY/WEB';
export const GET_AUTH_ORGANIZATIONS = 'GET_AUTH_ORGANIZATIONS/AUTH_ORGANIZATION/@WISELY/WEB';
export const FETCH_AUTH_ORGANIZATION_FAILED =
	'FETCH_AUTH_ORGANIZATION_FAILED/AUTH_ORGANIZATION/@WISELY/WEB';
export const FETCH_AUTH_ORGANIZATION_SUCCEEDED =
	'FETCH_AUTH_ORGANIZATION_SUCCEEDED/AUTH_ORGANIZATION/@WISELY/WEB';
export const FETCH_AUTH_ORGANIZATIONS_FAILED =
	'FETCH_AUTH_ORGANIZATIONS_FAILED/AUTH_ORGANIZATION/@WISELY/WEB';
export const FETCH_AUTH_ORGANIZATIONS_SUCCEEDED =
	'FETCH_AUTH_ORGANIZATIONS_SUCCEEDED/AUTH_ORGANIZATION/@WISELY/WEB';
export const UPDATE_AUTH_ORGANIZATION = 'UPDATE_AUTH_ORGANIZATION/AUTH_ORGANIZATION/@WISELY/WEB';
export const UPDATE_AUTH_ORGANIZATION_FAILED =
	'UPDATE_AUTH_ORGANIZATION_FAILED/AUTH_ORGANIZATION/@WISELY/WEB';
export const UPDATE_AUTH_ORGANIZATION_SUCCEEDED =
	'UPDATE_AUTH_ORGANIZATION_SUCCEEDED/AUTH_ORGANIZATION/@WISELY/WEB';
export const CREATE_AUTH_ORGANIZATION = 'CREATE_AUTH_ORGANIZATION/AUTH_ORGANIZATION/@WISELY/WEB';
export const CREATE_AUTH_ORGANIZATION_FAILED =
	'CREATE_AUTH_ORGANIZATION_FAILED/AUTH_ORGANIZATION/@WISELY/WEB';
export const CREATE_AUTH_ORGANIZATION_SUCCEEDED =
	'CREATE_AUTH_ORGANIZATION_SUCCEEDED/AUTH_ORGANIZATION/@WISELY/WEB';

export const clearAuthOrganizations = () => ({
	type: CLEAR_AUTH_ORGANIZATIONS,
});

export const clearAuthOrganizationUpdateErrors = () => ({
	type: CLEAR_AUTH_ORGANIZATION_UPDATE_ERRORS,
});

export const clearAuthOrganizationCreateErrors = () => ({
	type: CLEAR_AUTH_ORGANIZATION_CREATE_ERRORS,
});

export const getAuthOrganization = () => ({
	type: GET_AUTH_ORGANIZATION,
});

export const getAuthOrganizations = () => ({
	type: GET_AUTH_ORGANIZATIONS,
});

export const fetchAuthOrganizationFailed = payload => ({
	type: FETCH_AUTH_ORGANIZATION_FAILED,
	payload,
});

export const fetchAuthOrganizationSucceeded = payload => ({
	type: FETCH_AUTH_ORGANIZATION_SUCCEEDED,
	payload,
});

export const fetchAuthOrganizationsFailed = payload => ({
	type: FETCH_AUTH_ORGANIZATIONS_FAILED,
	payload,
});

export const fetchAuthOrganizationsSucceeded = payload => ({
	type: FETCH_AUTH_ORGANIZATIONS_SUCCEEDED,
	payload,
});

export const fetchAuthOrganization = (id, params) => {
	return dispatch => {
		dispatch(getAuthOrganization());
		const path = `organizations/${id}`;

		return getHandler(path, params, getAuthHost())
			.then(json => dispatch(fetchAuthOrganizationSucceeded(json)))
			.catch(error => {
				console.error('fetchAuthOrganization error', error);
				dispatch(fetchAuthOrganizationFailed());
			});
	};
};

export const fetchAuthOrganizations = params => {
	return async dispatch => {
		dispatch(getAuthOrganizations());
		const path = 'organizations';

		return getHandler(path, params, getAuthHost())
			.then(json => dispatch(fetchAuthOrganizationsSucceeded(json)))
			.catch(error => {
				console.error('fetchAuthOrganizations error', error);
				dispatch(fetchAuthOrganizationsFailed(error));
			});
	};
};

export const updateAuthOrganization = () => ({
	type: UPDATE_AUTH_ORGANIZATION,
});

export const requestUpdateAuthOrganizationFailed = payload => ({
	type: UPDATE_AUTH_ORGANIZATION_FAILED,
	payload,
});

export const requestUpdateAuthOrganizationSucceeded = payload => ({
	type: UPDATE_AUTH_ORGANIZATION_SUCCEEDED,
	payload,
});

export const requestUpdateAuthOrganization = (id, body) => {
	return async (dispatch, getState) => {
		if (getPendingAuthOrganizationUpdate(getState())) {
			return;
		}
		dispatch(updateAuthOrganization());
		const path = `organizations/${id}`;

		return patchHandler(path, JSON.stringify(body), null, getAuthHost())
			.then(json => dispatch(requestUpdateAuthOrganizationSucceeded(json)))
			.catch(error => {
				console.error('requestUpdateAuthOrganization error', error);
				dispatch(requestUpdateAuthOrganizationFailed(error));
			});
	};
};

export const createAuthOrganization = () => ({
	type: CREATE_AUTH_ORGANIZATION,
});

export const requestCreateAuthOrganizationFailed = payload => ({
	type: CREATE_AUTH_ORGANIZATION_FAILED,
	payload,
});

export const requestCreateAuthOrganizationSucceeded = payload => ({
	type: CREATE_AUTH_ORGANIZATION_SUCCEEDED,
	payload,
});

export const requestCreateAuthOrganization = body => {
	return async (dispatch, getState) => {
		if (getPendingAuthOrganizationCreate(getState())) {
			return;
		}
		dispatch(createAuthOrganization());
		const path = `organizations`;

		return postHandler(path, JSON.stringify(body), null, getAuthHost(), true)
			.then(json => {
				dispatch(requestCreateAuthOrganizationSucceeded(json));
			})
			.catch(error => {
				console.error('requestCreateAuthOrganization error', error);
				dispatch(requestCreateAuthOrganizationFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/authOrganizations/authOrganization.action.js